import { render } from "./TestimonialContent.vue?vue&type=template&id=769f64a2&scoped=true"
import script from "./TestimonialContent.vue?vue&type=script&lang=js"
export * from "./TestimonialContent.vue?vue&type=script&lang=js"

import "./TestimonialContent.vue?vue&type=style&index=0&id=769f64a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769f64a2"]])

export default __exports__